import { defineMessage } from "@lingui/macro";

export const SYSTEM = "system";
export const GENERAL = "general";
export const ACCOUNTS = "accounts";
export const SALES = "sales";
export const PRODUCT = "product";
export const HR = "hr";
export const BUSINESS = "business";
export const SPORTS = "sports";

export const ICON_URL = `${window.publicPath}media/images/channel/icons`;

export const ICON_TABS_LIST = [
  SYSTEM,
  GENERAL,
  ACCOUNTS,
  SALES,
  PRODUCT,
  HR,
  BUSINESS,
  SPORTS
];

export const ICON_TABS_MAPPING = {
  [SYSTEM]: {
    title: defineMessage`System icons`,
    id: "system",
    icons: [
      {
        id: "System1",
        names: ["Analytics", "system", "flowicon"],
        searchName: "Analytics system flowicon"
      },
      {
        id: "System2",
        names: ["App", "system", "flowicon"],
        searchName: "App system flowicon"
      },
      {
        id: "System3",
        names: ["Board", "system", "flowicon"],
        searchName: "Board system flowicon"
      },
      {
        id: "System4",
        names: ["Process", "system", "flowicon"],
        searchName: "Process system flowicon"
      },
      {
        id: "System5",
        names: ["Dataset", "system", "flowicon"],
        searchName: "Dataset system flowicon"
      },
      {
        id: "System6",
        names: ["Project", "system", "flowicon"],
        searchName: "Project system flowicon"
      },
      {
        id: "System7",
        names: ["Integration", "system", "flowicon"],
        searchName: "Integration system flowicon"
      },
      {
        id: "System8",
        names: ["List", "system", "flowicon"],
        searchName: "List system flowicon"
      },
      {
        id: "System9",
        names: ["Board", "system", "status", "new"],
        searchName: "Board system status new"
      },
      {
        id: "System10",
        names: ["Board", "system", "status", "inprogress"],
        searchName: "Board system status inprogress "
      },
      {
        id: "System11",
        names: ["Board", "system", "status", "resolved"],
        searchName: "Board system status resolved"
      },
      {
        id: "System12",
        names: ["Board", "system", "status", "closed"],
        searchName: "Board system status closed"
      },
      {
        id: "System13",
        names: ["Board", "system", "status", "reopened"],
        searchName: "Board system status reopened"
      }
    ]
  },
  [GENERAL]: {
    title: defineMessage`General`,
    id: "general",
    icons: [
      {
        id: "General1",
        names: ["Plugin", " extension", " puzzle"],
        searchName: "Plugin extension puzzle"
      },
      {
        id: "General2",
        names: ["File", " document", " paper"],
        searchName: "File document paper"
      },
      {
        id: "General3",
        names: ["ok", " like", " thumb's up"],
        searchName: "ok like thumb's up"
      },
      {
        id: "General4",
        names: ["user", " profile", " person", " member"],
        searchName: "user profile person member"
      },
      {
        id: "General5",
        names: ["Statistics", " bar chart"],
        searchName: "Statistics bar chart"
      },
      {
        id: "General6",
        names: ["Bag", " basket", " shopping", " purchase"],
        searchName: "Bag basket shopping purchase"
      },
      {
        id: "General7",
        names: ["pie chart", " analyse", " segment", " divide", " cut"],
        searchName: "pie chart analyse segment divide cut"
      },
      {
        id: "General8",
        names: ["bag", " work", " office", " briefcase", " suitcase"],
        searchName: "bag work office briefcase suitcase"
      },
      {
        id: "General9",
        names: ["star", " captain america shield", " protect", " save"],
        searchName: "star captain america shield protect save"
      },
      {
        id: "General10",
        names: ["list", " format"],
        searchName: "list format"
      },
      {
        id: "General11",
        names: ["Dollar", " currency", " coin", " money", " wealth", " rich"],
        searchName: "Dollar currency coin money wealth rich"
      },
      {
        id: "General12",
        names: ["board", " kanban", " layout", " panels"],
        searchName: "board kanban layout panels"
      },
      {
        id: "General13",
        names: [
          "done",
          " tick",
          " completed",
          " finished",
          " checked",
          " resolved"
        ],
        searchName: "done tick completed finished checked resolved"
      },
      {
        id: "General14",
        names: [
          "degree hat",
          " education",
          " graduate",
          " graduation",
          " school",
          " college"
        ],
        searchName: "degree hat education graduate graduation school college"
      },
      {
        id: "General15",
        names: ["umbrella", " protect", " rainy", " sunny"],
        searchName: "umbrella protect rainy sunny"
      },
      {
        id: "General16",
        names: ["flower", " wellness", " being", " bud", " bloom"],
        searchName: "flower wellness being bud bloom"
      },
      {
        id: "General17",
        names: ["book", " reading", " person", " studying"],
        searchName: "book reading person studying"
      },
      {
        id: "General18",
        names: ["colors palette", " artist", " painting"],
        searchName: "colors palette artist painting"
      },
      {
        id: "General19",
        names: [
          "safety shield",
          " secure",
          " protection",
          " protected",
          " security"
        ],
        searchName: "safety shield secure protection protected security"
      },
      {
        id: "General20",
        names: ["puzzles", " blocks", " boxes", " dashboard"],
        searchName: "puzzles blocks boxes dashboard"
      },
      {
        id: "General21",
        names: ["banking", " building"],
        searchName: "banking building"
      },
      {
        id: "General22",
        names: ["information", " more details"],
        searchName: "information more details"
      },
      {
        id: "General23",
        names: ["shopping bag", " hand", " locked", " secure"],
        searchName: "shopping bag hand locked secure"
      },
      {
        id: "General24",
        names: [
          "thunder",
          " lightning",
          " charge",
          " charging",
          " fast",
          " quick",
          " speed"
        ],
        searchName: "thunder lightning charge charging fast quick speed"
      }
    ]
  },
  [ACCOUNTS]: {
    title: defineMessage`Accounting & Finance`,
    id: "accounts",
    icons: [
      {
        id: "Accounts1",
        names: ["money bag", " sack", " dollar", " cost", " price"],
        searchName: "money bag sack dollar cost price"
      },
      {
        id: "Accounts2",
        names: ["Dollar", " currency", " coin", " money", " wealth"],
        searchName: "Dollar currency coin money wealth"
      },
      {
        id: "Accounts3",
        names: ["wallet", " purse"],
        searchName: "wallet purse"
      },
      {
        id: "Accounts4",
        names: ["money bag", " sack", " cost", " price", " divide"],
        searchName: "money bag sack cost price divide"
      },
      {
        id: "Accounts5",
        names: ["debit", " atm", " credit", " visa", " master card"],
        searchName: "debit atm credit visa master card"
      },
      {
        id: "Accounts6",
        names: ["banking", " building"],
        searchName: "banking building"
      },
      {
        id: "Accounts7",
        names: ["savings", " save money", " deposit", " piggy bank"],
        searchName: "savings save money deposit piggy bank"
      },
      {
        id: "Accounts8",
        names: ["bank", " banking", " usa", " dollar"],
        searchName: "bank banking usa dollar"
      },
      {
        id: "Accounts9",
        names: ["graph", " chart", " bar", " growth", " profit"],
        searchName: "graph chart bar growth profit"
      },
      {
        id: "Accounts10",
        names: ["rapid", " graph", " chart", " bar", " growth", " profit"],
        searchName: "rapid graph chart bar growth profit"
      },
      {
        id: "Accounts11",
        names: ["bright idea", " bulb glowing"],
        searchName: "bright idea bulb glowing"
      },
      {
        id: "Accounts12",
        names: ["saving", " save", " deposit", " banking"],
        searchName: "saving save deposit banking"
      },
      {
        id: "Accounts13",
        names: [
          "pie chart",
          " dollar",
          " finance report",
          " financial",
          " analysis"
        ],
        searchName: "pie chart dollar finance report financial analysis"
      },
      {
        id: "Accounts14",
        names: ["bar chart", " rising", " rise in value", " dollar"],
        searchName: "bar chart rising rise in value dollar"
      },
      {
        id: "Accounts15",
        names: ["pie chart", " segment", " piece", " part"],
        searchName: "pie chart segment piece part"
      },
      {
        id: "Accounts16",
        names: ["bag", " work", " office", " briefcase", " suitcase"],
        searchName: "bag work office briefcase suitcase"
      },
      {
        id: "Accounts17",
        names: [
          "money book",
          " dollar",
          " business note",
          " finance",
          " account",
          " financial report"
        ],
        searchName:
          "money book dollar business note finance account financial report"
      },
      {
        id: "Accounts18",
        names: ["cash", " money", " currency", " cards"],
        searchName: "cash money currency cards"
      },
      {
        id: "Accounts19",
        names: ["money bag", " sack", " dollar", " cost", " price"],
        searchName: "money bag sack dollar cost price"
      },
      {
        id: "Accounts20",
        names: ["currency", " money", " coin stack"],
        searchName: "currency money coin stack"
      },
      {
        id: "Accounts21",
        names: ["currency", " money", " coin stack", " dollar"],
        searchName: "currency money coin stack dollar"
      },
      {
        id: "Accounts22",
        names: ["bar chart", " graph"],
        searchName: "bar chart graph"
      },
      {
        id: "Accounts23",
        names: ["financial report", " document", " mathematics note"],
        searchName: "financial report document mathematics note"
      },
      {
        id: "Accounts24",
        names: ["savings", " save money", " deposit", " piggy bank"],
        searchName: "savings save money deposit piggy bank"
      }
    ]
  },
  [SALES]: {
    title: defineMessage`Sales & Marketing`,
    id: "sales",
    icons: [
      {
        id: "Sales1",
        names: ["percentage", " discount", " offer"],
        searchName: "percentage discount offer"
      },
      {
        id: "Sales2",
        names: ["shopping", " cart"],
        searchName: "shopping cart"
      },
      {
        id: "Sales3",
        names: ["price tag", " label"],
        searchName: "price tag label"
      },
      {
        id: "Sales4",
        names: ["shopping cart"],
        searchName: "shopping cart"
      },
      {
        id: "Sales5",
        names: ["percentage", " square"],
        searchName: "percentage square"
      },
      {
        id: "Sales6",
        names: ["dollar", " price", " currency", " money", " sticker"],
        searchName: "dollar price currency money sticker"
      },
      {
        id: "Sales7",
        names: ["star ribbon", " emblem", " badge"],
        searchName: "star ribbon emblem badge"
      },
      {
        id: "Sales8",
        names: ["bag", " handbag", " purse"],
        searchName: "bag handbag purse"
      },
      {
        id: "Sales9",
        names: ["sound", " speaker", " voice", " horn", " noise", " loud"],
        searchName: "sound speaker voice horn noise loud"
      },
      {
        id: "Sales10",
        names: ["hand bag", " purse", " shopping", " cart"],
        searchName: "hand bag purse shopping cart"
      },
      {
        id: "Sales11",
        names: [
          "rapid growth",
          " graph",
          " bar chart",
          " trending",
          " popular",
          " upward",
          " profit"
        ],
        searchName:
          "rapid growth graph bar chart trending popular upward profit"
      },
      {
        id: "Sales12",
        names: ["Rocket", " take off", " initialize", " start"],
        searchName: "Rocket take off initialize start"
      },
      {
        id: "Sales13",
        names: ["movie", " trailer", " video", " film"],
        searchName: "movie trailer video film"
      },
      {
        id: "Sales14",
        names: ["champion", " trophy", " winner", " cup", " first place"],
        searchName: "champion trophy winner cup first place"
      },
      {
        id: "Sales15",
        names: ["pie chart", " analyse", " segment", " divide", " cut"],
        searchName: "pie chart analyse segment divide cut"
      },
      {
        id: "Sales16",
        names: ["file", " document", " growth report", " growth", " business"],
        searchName: "file document growth report growth business"
      },
      {
        id: "Sales17",
        names: ["bar chart arrow up", " benefit"],
        searchName: "bar chart arrow up benefit"
      },
      {
        id: "Sales18",
        names: ["ticket", " price label", " discount coupon"],
        searchName: "ticket price label discount coupon"
      },
      {
        id: "Sales19",
        names: [
          "target",
          " achievement",
          " goal",
          " objective",
          " dartboard",
          " aim"
        ],
        searchName: "target achievement goal objective dartboard aim"
      },
      {
        id: "Sales20",
        names: ["prize", " ribbon badge", " award"],
        searchName: "prize ribbon badge award"
      },
      {
        id: "Sales21",
        names: ["okay", " like", " thumb's up"],
        searchName: "okay like thumb's up"
      },
      {
        id: "Sales22",
        names: ["target board", " aim", " scope"],
        searchName: "target board aim scope"
      },
      {
        id: "Sales23",
        names: ["pie chart", " donut"],
        searchName: "pie chart donut"
      },
      {
        id: "Sales24",
        names: ["handbag", " purse", " shopping bag", " cart", " basket"],
        searchName: "handbag purse shopping bag cart basket"
      }
    ]
  },
  [HR]: {
    title: defineMessage`HR & Operations`,
    id: "hr",
    icons: [
      {
        id: "Hr1",
        names: ["bag", " work", " office", " briefcase", " suitcase"],
        searchName: "bag work office briefcase suitcase"
      },
      {
        id: "Hr2",
        names: [
          "multistorey building",
          " headquarters",
          " office",
          " apartment",
          " house"
        ],
        searchName: "multistorey building headquarters office apartment house"
      },
      {
        id: "Hr3",
        names: ["User", " person", " employee", " human"],
        searchName: "User person employee human"
      },
      {
        id: "Hr4",
        names: ["target", " goal", " objective", " dartboard", " aim"],
        searchName: "target goal objective dartboard aim"
      },
      {
        id: "Hr5",
        names: ["search", " find", " magnify", " magnifier glass"],
        searchName: "search find magnify magnifier glass"
      },
      {
        id: "Hr6",
        names: ["message", " user details"],
        searchName: "message user details"
      },
      {
        id: "Hr7",
        names: ["Folder", " document", " papers"],
        searchName: "Folder document papers"
      },
      {
        id: "Hr8",
        names: ["time", " sandglass", " second", " hourglass", " second"],
        searchName: "time sandglass second hourglass second"
      },
      {
        id: "Hr9",
        names: ["chair", " seat"],
        searchName: "chair seat"
      },
      {
        id: "Hr10",
        names: ["documents", " duplicate", " copy"],
        searchName: "documents duplicate copy"
      },
      {
        id: "Hr11",
        names: ["Shield", " award", "  prize"],
        searchName: "Shield award  prize"
      },
      {
        id: "Hr12",
        names: ["bonus card", " card"],
        searchName: "bonus card card"
      },
      {
        id: "Hr13",
        names: ["verify setting", " gear", " approved", " checked tool"],
        searchName: "verify setting gear approved checked tool"
      },
      {
        id: "Hr14",
        names: [
          "calendar",
          " task done",
          " appointment",
          " approved event",
          " verify date"
        ],
        searchName: "calendar task done appointment approved event verify date"
      },
      {
        id: "Hr15",
        names: ["user", " person", " people", " groups", " crowd"],
        searchName: "user person people groups crowd"
      },
      {
        id: "Hr16",
        names: ["done", " tick", " completed", " finished", " checked"],
        searchName: "done tick completed finished checked"
      },
      {
        id: "Hr17",
        names: ["Flow", " flow diagram", " classification", " classify"],
        searchName: "Flow flow diagram classification classify"
      },
      {
        id: "Hr18",
        names: ["stamp", " mark", " seal", " wax seal", " business stamp"],
        searchName: "stamp mark seal wax seal business stamp"
      },
      {
        id: "Hr19",
        names: ["Laptop", " system", " computer", " pc", " notebook"],
        searchName: "Laptop system computer pc notebook"
      },
      {
        id: "Hr20",
        names: ["People", " partner", " person", " pair", " joint"],
        searchName: "People partner person pair joint"
      },
      {
        id: "Hr21",
        names: ["Gear", " settings", " configuration", " configure"],
        searchName: "Gear settings configuration configure"
      },
      {
        id: "Hr22",
        names: ["globe", " www", " server", " internet", " network"],
        searchName: "globe www server internet network"
      },
      {
        id: "Hr23",
        names: ["User settings", " user management", " manage"],
        searchName: "User settings user management manage"
      },
      {
        id: "Hr24",
        names: ["Employee", " employer", " user", " person", " businessman"],
        searchName: "Employee employer user person businessman"
      }
    ]
  },
  [PRODUCT]: {
    title: defineMessage`Production & Manufacturing`,
    id: "product",
    icons: [
      {
        id: "Product1",
        names: ["building", " apartment"],
        searchName: "building apartment"
      },

      {
        id: "Product2",
        names: [
          "Factory",
          " industry",
          " manufacturing plant",
          " power plant",
          " production"
        ],
        searchName:
          "Factory industry manufacturing plant power plant production"
      },

      {
        id: "Product3",
        names: ["shipping", " shipment", " ship", " cargo", " delivery"],
        searchName: "shipping shipment ship cargo delivery"
      },

      {
        id: "Product4",
        names: ["lorry", " truck", " van", " transportation", " delivery"],
        searchName: "lorry truck van transportation delivery"
      },

      {
        id: "Product5",
        names: ["Gear", " settings", " configuration", " configure"],
        searchName: "Gear settings configuration configure"
      },

      {
        id: "Product6",
        names: ["box", " parcel", " delivery", " order"],
        searchName: "box parcel delivery order"
      },

      {
        id: "Product7",
        names: [
          "Factory",
          " industry",
          " manufacturing plant",
          " power plant",
          " production"
        ],
        searchName:
          "Factory industry manufacturing plant power plant production"
      },

      {
        id: "Product8",
        names: ["settings", " gear", " safety", " security", " protection"],
        searchName: "settings gear safety security protection"
      },

      {
        id: "Product9",
        names: [
          "screw driver",
          " spanner",
          " issue",
          " problem",
          " troubleshooting",
          " service",
          " maintenance"
        ],
        searchName:
          "screw driver spanner issue problem troubleshooting service maintenance"
      },

      {
        id: "Product10",
        names: [
          "robot",
          " assembly robot",
          " automation",
          " automatic robot",
          " machine"
        ],
        searchName: "robot assembly robot automation automatic robot machine"
      },

      {
        id: "Product11",
        names: ["crane", " machine"],
        searchName: "crane machine"
      },

      {
        id: "Product12",
        names: ["geometry", " divider", " compass"],
        searchName: "geometry divider compass"
      },

      {
        id: "Product13",
        names: [
          "industry",
          " manufacturing plant",
          " power",
          " production",
          " cloud connected advanced factory"
        ],
        searchName:
          "industry manufacturing plant power production cloud connected advanced factory"
      },

      {
        id: "Product14",
        names: [
          "Factory",
          " industry",
          " manufacturing plant",
          " power",
          " production"
        ],
        searchName: "Factory industry manufacturing plant power production"
      },

      {
        id: "Product15",
        names: ["bag", " work", " office", " briefcase", " suitcase"],
        searchName: "bag work office briefcase suitcase"
      },

      {
        id: "Product16",
        names: [
          "Power generation",
          " production plant",
          " nuclear",
          " industrial smoke"
        ],
        searchName: "Power generation production plant nuclear industrial smoke"
      },

      {
        id: "Product17",
        names: ["box", " parcel", " delivery", " order"],
        searchName: "box parcel delivery order"
      },

      {
        id: "Product18",
        names: ["lorry", " truck", " van", " transportation", " delivery"],
        searchName: "lorry truck van transportation delivery"
      },

      {
        id: "Product19",
        names: [
          "delivered",
          " lorry",
          " truck",
          " van",
          " transportation",
          " delivery"
        ],
        searchName: "delivered lorry truck van transportation delivery"
      },

      {
        id: "Product20",
        names: ["Rocket", " take off", " initialize", " start"],
        searchName: "Rocket take off initialize start"
      },

      {
        id: "Product21",
        names: ["construction helmet", " safety", " industrial", " worker cap"],
        searchName: "construction helmet safety industrial worker cap"
      },

      {
        id: "Product22",
        names: ["to do list", " checklist", " pad"],
        searchName: "to do list checklist pad"
      },

      {
        id: "Product23",
        names: [
          "assembly line",
          " setting",
          " conveyor",
          " production",
          " manufacture"
        ],
        searchName: "assembly line setting conveyor production manufacture"
      },

      {
        id: "Product24",
        names: ["gear", " settings", " configuration", " configure"],
        searchName: "gear settings configuration configure"
      }
    ]
  },
  [BUSINESS]: {
    title: defineMessage`Business`,
    id: "business",
    icons: [
      {
        id: "Business1",
        names: ["bag", " briefcase", " suitcase"],
        searchName: "bag briefcase suitcase"
      },
      {
        id: "Business2",
        names: ["round table", " conference", " meeting"],
        searchName: "round table conference meeting"
      },
      {
        id: "Business3",
        names: ["trophy", " cup"],
        searchName: "trophy cup"
      },
      {
        id: "Business4",
        names: ["target", " dartboard"],
        searchName: "target dartboard"
      },
      {
        id: "Business5",
        names: ["prize", " badge", " ribbon"],
        searchName: "prize badge ribbon"
      },
      {
        id: "Business6",
        names: ["hand shake"],
        searchName: "hand shake"
      },
      {
        id: "Business7",
        names: ["calculator"],
        searchName: "calculator"
      },
      {
        id: "Business8",
        names: ["idea", " bulb", " glow"],
        searchName: "idea bulb glow"
      },
      {
        id: "Business9",
        names: ["graph", " bar chart", " trending", " growth", " profit"],
        searchName: "graph bar chart trending growth profit"
      },
      {
        id: "Business10",
        names: ["chart", " pie chart", " donut pie chart", " donut chart"],
        searchName: "chart pie chart donut pie chart donut chart"
      },
      {
        id: "Business11",
        names: ["target", " goal", " objective", " dartboard", " aim"],
        searchName: "target goal objective dartboard aim"
      },
      {
        id: "Business12",
        names: ["bar", " bar chart", " growth chart"],
        searchName: "bar bar chart growth chart"
      },
      {
        id: "Business13",
        names: ["report", " document", " business report", " business data"],
        searchName: "report document business report business data"
      },
      {
        id: "Business14",
        names: ["money bag", " money sack", " dollar", " cost", " price"],
        searchName: "money bag money sack dollar cost price"
      },
      {
        id: "Business15",
        names: ["graph", " bar chart", " stock market", " growth", " profit"],
        searchName: "graph bar chart stock market growth profit"
      },
      {
        id: "Business16",
        names: ["Rocket", " take off"],
        searchName: "Rocket take off"
      },
      {
        id: "Business17",
        names: [
          "card",
          " id card",
          " identity card",
          " identity proof",
          " id proof"
        ],
        searchName: "card id card identity card identity proof id proof"
      },
      {
        id: "Business18",
        names: ["Gear", " settings", " configuration", " configure", " set"],
        searchName: "Gear settings configuration configure set"
      },
      {
        id: "Business19",
        names: ["Employee", " employer", " user", " person", " businessman"],
        searchName: "Employee employer user person businessman"
      },
      {
        id: "Business20",
        names: ["wallet", " purse"],
        searchName: "wallet purse"
      },
      {
        id: "Business21",
        names: [
          "partnership",
          " friendship",
          " hand shake",
          " deal",
          " agreement"
        ],
        searchName: "partnership friendship hand shake deal agreement"
      },
      {
        id: "Business22",
        names: [
          "projector",
          " finance report",
          " board",
          " chart",
          " business report"
        ],
        searchName: "projector finance report board chart business report"
      },
      {
        id: "Business23",
        names: ["bar chart", " chart", " bar", " bar graph"],
        searchName: "bar chart chart bar bar graph"
      },
      {
        id: "Business24",
        names: ["globe", " www", " server", " internet", " network"],
        searchName: "globe www server internet network"
      }
    ]
  },
  [SPORTS]: {
    title: defineMessage`Sports & Entertainment`,
    id: "sports",
    icons: [
      {
        id: "Sports1",
        names: ["ball", " sport", " basketball", " play", " game"],
        searchName: "ball sport basketball play game"
      },
      {
        id: "Sports2",
        names: ["cycling", " riding", " bicycle", " bike", " workout"],
        searchName: "cycling riding bicycle bike workout"
      },
      {
        id: "Sports3",
        names: ["dumb bells", " exercise", " workout", " gym", " fitness"],
        searchName: "dumb bells exercise workout gym fitness"
      },
      {
        id: "Sports4",
        names: ["football", " American football", " rugby"],
        searchName: "football American football rugby"
      },
      {
        id: "Sports5",
        names: ["sport", " basketball", " play", " game"],
        searchName: "sport basketball play game"
      },
      {
        id: "Sports6",
        names: ["champion", " trophy", " winner", " cup", " first place"],
        searchName: "champion trophy winner cup first place"
      },
      {
        id: "Sports7",
        names: ["champion", " trophy", " winner", " cup", " first place"],
        searchName: "champion trophy winner cup first place"
      },
      {
        id: "Sports8",
        names: ["shuttle cock", " badminton", " fly", " smash", " sport"],
        searchName: "shuttle cock badminton fly smash sport"
      },
      {
        id: "Sports9",
        names: ["table tennis", " player", " sport", " game"],
        searchName: "table tennis player sport game"
      },
      {
        id: "Sports10",
        names: ["shoe", " run", " walk", " jog", " sneaker"],
        searchName: "shoe run walk jog sneaker"
      },
      {
        id: "Sports11",
        names: ["action", " cut", " movie", " film", " clapperboard"],
        searchName: "action cut movie film clapperboard"
      },
      {
        id: "Sports12",
        names: ["popcorn", " movie", " entertainment", " snack"],
        searchName: "popcorn movie entertainment snack"
      },
      {
        id: "Sports13",
        names: [
          "video recorder",
          " video camera",
          " direct",
          " film",
          " movie"
        ],
        searchName: "video recorder video camera direct film movie"
      },
      {
        id: "Sports14",
        names: ["tent", " circus", " circus tent"],
        searchName: "tent circus circus tent"
      },
      {
        id: "Sports15",
        names: ["ticket", " movie ticket"],
        searchName: "ticket movie ticket"
      },
      {
        id: "Sports16",
        names: ["camera", " photoshoot", " capture", " snapshot", " picture"],
        searchName: "camera photoshoot capture snapshot picture"
      },
      {
        id: "Sports17",
        names: [
          "headphone",
          " earphone",
          " noise cancellation",
          " hear",
          " music"
        ],
        searchName: "headphone earphone noise cancellation hear music"
      },
      {
        id: "Sports18",
        names: ["music", " play", " song", " sound", " entertainment"],
        searchName: "music play song sound entertainment"
      },
      {
        id: "Sports19",
        names: [
          "joystick",
          " video game",
          " playstation",
          " xbox",
          " entertainment"
        ],
        searchName: "joystick video game playstation xbox entertainment"
      },
      {
        id: "Sports20",
        names: ["puzzle", " extension", " plugin", " piece"],
        searchName: "puzzle extension plugin piece"
      },
      {
        id: "Sports21",
        names: ["game", " chessboard", " knight", " horse", " chess coin"],
        searchName: "game chessboard knight horse chess coin"
      },
      {
        id: "Sports22",
        names: ["winner", " 1st place", " first position", " medal"],
        searchName: "winner 1st place first position medal"
      },
      {
        id: "Sports23",
        names: ["helmet", " baseball", " sport", " cap", " hat"],
        searchName: "helmet baseball sport cap hat"
      },
      {
        id: "Sports24",
        names: ["Steering wheel", " driver", " car", " automobile", " turn"],
        searchName: "Steering wheel driver car automobile turn"
      }
    ]
  }
};
